module.exports = __webpack_public_path__ + "images/youtube.jpg";


//////////////////
// WEBPACK FOOTER
// ./vively/images/social-media-icons/youtube.jpg
// module id = 878
// module chunks = 3